exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._37cs4U6aROjMBUtlBvypDB{padding:0}._3I4YaEIGmFuZOY44JWP2Qf{height:calc(100% - 10px)}html[dir] ._3mX6uzlJaX_HM6amvinCqp .ms-Panel-content{padding:0!important}._2eBCrCd3KVSb0OiYec0VQ4{height:100%}", ""]);

// exports
exports.locals = {
	"todoFlexPaneContent": "_37cs4U6aROjMBUtlBvypDB",
	"todoFlexPanePanelContainer": "_3I4YaEIGmFuZOY44JWP2Qf",
	"todoFlex": "_3mX6uzlJaX_HM6amvinCqp",
	"todosPane": "_2eBCrCd3KVSb0OiYec0VQ4"
};